import { render, staticRenderFns } from "./ModalEnviarParaRetornoDeCotacaoBtn.vue?vue&type=template&id=3e6df6c7&scoped=true"
import script from "./ModalEnviarParaRetornoDeCotacaoBtn.vue?vue&type=script&lang=ts"
export * from "./ModalEnviarParaRetornoDeCotacaoBtn.vue?vue&type=script&lang=ts"
import style0 from "./ModalEnviarParaRetornoDeCotacaoBtn.vue?vue&type=style&index=0&id=3e6df6c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6df6c7",
  null
  
)

export default component.exports